import FormAttend from './form-attend/script';
import FormSignIn from './form-sign-in/script';

export default {
	[FormAttend.selector]: FormAttend,
	[FormSignIn.selector]: FormSignIn,
};
